import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import AppRoutes from "./Router";
import { BrowserRouter } from "react-router-dom";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.Fragment>
    <BrowserRouter basename="/">
      <AppRoutes />
    </BrowserRouter>
  </React.Fragment>
);
